import type { PartialDeep } from 'type-fest';
import { Configuration } from '../defaultConfig';
import ethereum from './ethereum';
import casper from './casper';
import solana from './solana';

const stageConfig: Record<string, PartialDeep<Configuration>> = {
  ethereum,
  casper,
  solana,
};

export default stageConfig;
